import { request } from "../request";
const mock = "";

// 保存评价
export const convertCdKey = (params) =>
  request(`${mock}/v1/enrollment/convertCdKey`, "POST", { json: params });
